import Vue from "vue";
import Vuex from "vuex";
import {isEmpty, logger} from "../../plagins/utils";
import {CommandsExternal, CommandsInner, Kt, KtSetting, Record, Settings, Template} from "../interfaces";
import {changeLanguage} from "../../plagins/translate";
import {templates} from "../templates/settings";

Vue.use(Vuex);

export interface Fields {
    dist: string;
    gender: string;
    selected_kt_setting: KtSetting;
    font_size: number;
}

export interface RemoteData {
    host: string;
    port: number;
    debug: boolean;
    event: string;
    lang: string;
    title: string;

}


export interface State {
    settings: Settings;

    records: Record[];
    first_record: Record | any;
    limit: number;
    delay_update: number
    loading: boolean;
    in_width: boolean;
    full_screen: boolean;

    template: Template;
    templates: Template[];

    fields: Fields;

    kt_settings_by_name: { [id: string]: KtSetting };
    remote_data: RemoteData;

}


// @ts-ignore
const REMOTE_DATA: RemoteData = window.json_context;
const INTERVAL_SOCKET_CHECK = 10 * 1000; //ms
const SOCKET_URL = 'ws://' + REMOTE_DATA.host + '/tracking-athletes/';

changeLanguage(REMOTE_DATA.lang);

//INITIALIZATION SOCKET
let ws = new WebSocket(SOCKET_URL);
ws.onmessage = function (event) {
    store.commit('update', JSON.parse(event.data));
};

//RECONNECT SOCKET
function socket_check() {
    if (!ws || ws.readyState === 3) {
        ws = new WebSocket(SOCKET_URL);
        ws.onmessage = function (event) {
            store.commit('update', JSON.parse(event.data));
        };
    }
}

setInterval(socket_check, INTERVAL_SOCKET_CHECK);//10 sec.

let timeUpdated: number = Date.now();

class MainWorker {

    ws_commands: { [id: string]: (request: any) => void } = {};


    constructor() {
        // store.commit('set_title', store.state.remote_data.title);

        this.initCallbackFunctions();

    }

    // getKtTitle(selected_kt_setting: Kt) {
    //     return store.state.settings.columns[selected_kt_setting.id].title;
    // }

    subscribeOnUpdateData(request: any): void {
        store.commit('set_loading', true);

        let dist = '';
        if (!!store.state.fields.dist) {
            dist = store.state.fields.dist;
        }
        let gender = '';
        if (!!store.state.fields.gender) {
            gender = store.state.fields.gender;
        }
        timeUpdated = 0;


        let message: { command: string, event: string, data: any } = {
            event: store.state.remote_data.event,
            command: CommandsExternal.SUBSCRIBE_ON_UPDATE_DATA,
            data: {
                selected_kt: store.state.fields.selected_kt_setting.id,
                dist: dist,
                gender: gender
            }
        };

        // loggerr(message);

        ws.send(JSON.stringify(message));

        // this.loading = true;
    }


    getSettings(request: any): void {

        let message: { command: string, event: string, lang: string } = {
            event: store.state.remote_data.event,
            command: CommandsExternal.GET_SETTINGS,
            lang: store.state.remote_data.lang
        };
        let json_message = JSON.stringify(message);
        ws.send(json_message);
    }


    callbackGetSettings(request: any): void {
        if (request.data) {

            store.commit('set_settings', request.data.data);

            let kt_settings_by_name: { [id: string]: KtSetting } = {};

            for (let i = 0; i < store.state.settings.columns.length; i++) {
                let kt_setting: KtSetting = store.state.settings.columns[i];
                if (!isEmpty(kt_setting.name)) {
                    kt_settings_by_name[kt_setting.name] = kt_setting;
                }
            }

            store.commit('set_kt_settings_by_name', kt_settings_by_name);


            store.commit('set_loading', false);


            Vue.set(store.state.fields, 'selected_kt_setting', store.state.settings.control_points_columns[0]);

            store.commit('subscribe_on_update_data');
        }
    }

    static createRecord(source_record: any): Record {

        let bib = 0;
        let name = '';
        let dist = null;
        let gun = '';
        let start = '';
        let guntime = '';
        let chiptime = '';
        let result = '';
        let finish = '';
        let last_kt: Kt = {
            id: 0,
            value: null
        };

        let kts: Kt[] = [];
        let all_kts: Kt[] = [];
        let kts_dict: { [id: string]: Kt } = {};


        for (let j = 0; j < source_record.length; j++) {
            all_kts.push(source_record[j]);
            if (!!store.state.settings.columns[j].name) {
                kts_dict[store.state.settings.columns[j].name] = source_record[j]
            }

            if (store.state.settings.columns[j].name === 'bib') {
                bib = source_record[j].value;
                continue;
            }
            if (store.state.settings.columns[j].name === 'gun') {
                gun = source_record[j].value;
                continue;
            }
            if (store.state.settings.columns[j].name === 'start') {
                start = source_record[j].value;
                continue;
            }
            if (store.state.settings.columns[j].name === 'guntime') {
                guntime = source_record[j].value;
                continue;
            }
            if (store.state.settings.columns[j].name === 'finish') {
                finish = source_record[j].value;
                continue;
            }
            if (store.state.settings.columns[j].name === 'chiptime') {
                chiptime = source_record[j].value;
                continue;
            }
            if (store.state.settings.columns[j].name === 'result') {
                result = source_record[j].value;
                continue;
            }
            if (store.state.settings.columns[j].name === 'last_name') {
                if (name.length > 0) name += ' ';
                name += source_record[j].value;
                continue;
            }
            if (store.state.settings.columns[j].name === 'first_name') {
                if (name.length > 0) name += ' ';
                name += source_record[j].value;
                continue;
            }
            if ((store.state.settings.columns[j].name === 'dist')) {
                dist = store.state.settings.columns[j].name;
                continue;
            }
            kts.push(source_record[j])
        }


        return {
            selected: false,
            bib: bib,
            dist: dist,
            name: name,
            gun: gun,
            start: start,
            guntime: guntime,
            chiptime: chiptime,
            finish: finish,
            result: result,
            last_kt: last_kt,
            kts: kts,
            all_kts: all_kts,
            kts_dict: kts_dict
        }
    }

    callbackUpdateData(request: any): void {
        if (request.data) {
            if (store.state.records.length === 0 || Date.now() - timeUpdated > 1000 * store.state.delay_update) {
                logger(`${Date.now() - timeUpdated}mcs`);
                timeUpdated = Date.now();

                let records: Record[] = [];
                for (let i = 0; i < request.data.records.length; i++) {
                    records.push(MainWorker.createRecord(request.data.records[i]))
                }
                // logger(records);
                store.commit('set_records', records);

                let first_record = MainWorker.createRecord(request.data.first_record);
                store.commit('set_first_record', first_record);
            }
            store.commit('set_loading', false);
        }
    }

    applyFilter() {
        store.commit('subscribe_on_update_data');
        store.commit('set_drawer_right_toolbar', false);
    }


    update(request: any) {
        if (!this.ws_commands) return;

        if (!request.command || !this.ws_commands[request.command]) {
            return
        }
        this.ws_commands[request.command](request);
    }


    initCallbackFunctions() {
        this.ws_commands[CommandsInner.UPDATE_DATA] = this.callbackUpdateData;
        this.ws_commands[CommandsInner.SUBSCRIBE_ON_UPDATE_DATA] = this.subscribeOnUpdateData;
        this.ws_commands[CommandsInner.GET_SETTINGS] = this.getSettings;
        this.ws_commands[CommandsInner.CALLBACK_GET_SETTINGS] = this.callbackGetSettings;

        this.ws_commands[CommandsInner.UPDATE_SETTINGS] = this.callbackUpdateData;
    }

}

let main_worker: MainWorker = new MainWorker();

let store = new Vuex.Store({
    state: {
        loading: true,
        template: templates[0],
        templates: templates,

        in_width: false,
        full_screen: false,
        drawer_right_toolbar: false,
        title: "TIMING LITE",
        settings: {
            table: {
                hash: 0,
                is_active: true,
                order: {
                    column_id: 0
                },
            },
            columns: [
                {
                    id: 0,
                    name: '',
                    title: '',
                    is_show: true,
                    is_time: true,
                }
            ],
            control_points_columns: [
                {
                    id: 0,
                    name: '',
                    title: '',
                    is_show: true,
                    is_time: true,

                }
            ]
        },
        records: [],
        first_record: {},
        limit: 10,
        delay_update: 0,
        fields: {
            dist: '',
            gender: '',
            selected_kt_setting: {
                id: 0,
                name: '',
                title: '',
                is_show: true,
                is_time: true,
            },
            font_size: 1.2
        },

        kt_settings_by_name: {
            dist: {
                id: 0,
                name: '',
                title: '',
                is_show: true,
                is_time: false,
                drop_down: []
            }
        },
        remote_data: REMOTE_DATA
    },
    mutations: {

        change_drawer_right_toolbar(state, response) {
            let drawer: boolean = !state.drawer_right_toolbar;
            Vue.set(state, 'drawer_right_toolbar', drawer);

        },
        set_drawer_right_toolbar(state, is_open: boolean) {
            Vue.set(state, 'drawer_right_toolbar', is_open);
        },

        set_loading(state, loading: boolean) {
            Vue.set(state, 'loading', loading);
        },

        set_title(state, title: string) {
            Vue.set(state, 'title', title);
        },
        set_settings(state, settings: Settings) {
            Vue.set(state, 'settings', settings);
        },

        set_kt_settings_by_name(state: State, kt_settings_by_name: { [id: string]: KtSetting }) {
            Vue.set(state, 'kt_settings_by_name', kt_settings_by_name);
        },


        set_records(state: State, records: Record[]) {
            Vue.set(state, 'records', records);
        },
        set_first_record(state: State, record: Record) {
            Vue.set(state, 'first_record', record);
        },

        subscribe_on_update_data(state: State) {
            main_worker.subscribeOnUpdateData(null);
        },
        update(state: State, data: any) {
            logger("update: ", data);
            main_worker.update(data);
        },
        clean_data(state) {
            Vue.set(state, 'title', "TRACKING ATHLETES");
        },


    },
    actions: {
        // increment(context) {
        //     logger("increment, actions");
        //     context.commit('increment');
        // }
    }
});
export default store;



